<template>
  <div class="h-full bg-white overflow-y-auto absolute w-full flex flex-col">
    <Link
      class="block py-3 bg-primary-color"
      :href="$routes.user_course(course.user_course_id)"
      aria-label="Dashboard"
    >
      <div class="text-white py-2 px-4 font-bold">
        {{ course.name }}
      </div>
    </Link>
    <div class="border-r-2 grow">
      <template
        v-for="chapter_id in course.ordered_chapter_ids"
        :key="chapter_id"
      >
        <div class="mt-3 justify-center rounded-l-md font-bold text-md px-3">
          {{ course.chapters[chapter_id].name }}
        </div>
        <Link
          v-for="(subject_id, indexS) in course.chapters[chapter_id]
            .ordered_subjects_ids"
          :key="subject_id"
          :ref="subject_id === currentSubjectId ? 'current_subject' : ''"
          :href="$routes.subject(subject_id)"
          class="rounded-md flex flex-row bg-white py-3 px-3 text-md pointer border-b"
          :class="subject_id === currentSubjectId ? 'text-primary-color' : ''"
        >
          <template
            v-if="
              course.chapters[chapter_id].subjects[subject_id].type ===
              'VideoSubject'
            "
          >
            <i
              v-if="markedList.includes(subject_id)"
              class="pi pi-check-circle mr-2 text-secondary-color text-base"
            ></i>
            <i v-else class="pi pi-circle mr-2 text-gray-500 text-base"></i>
          </template>
          <template
            v-else-if="
              course.chapters[chapter_id].subjects[subject_id].type ===
              'FeedbackSubject'
            "
          >
            <i class="pi pi-cloud-upload mr-2 text-black text-base"></i>
          </template>
          <template
            v-else-if="
              course.chapters[chapter_id].subjects[subject_id].type ===
              'QuizSubject'
            "
          >
            <i class="pi pi-question-circle mr-2 text-black text-base"></i>
          </template>
          <template v-else>
            <i class="pi pi-file mr-2 text-black text-base"></i>
          </template>
          {{
            indexS +
            1 +
            '. ' +
            course.chapters[chapter_id].subjects[subject_id].name
          }}
        </Link>
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
export default {
  name: 'SidebarSection',
  components: { Link },
  props: {
    course: { type: Object, required: true },
    markedList: { type: Array, required: true },
    currentSubjectId: { type: [String, Number], required: true },
  },
  mounted() {
    this.$refs.current_subject[0].$el.scrollIntoView({
      behaviour: 'smooth',
      block: 'center',
    });
  },
};
</script>
